import { createPortal } from "react-dom";
import { ModalBackdrop, ModalDialog, ModalWrapper } from "./Modal.styles";

const Modal = ({ children, onDismiss, show, size = "md", className = "" }) => {
    return createPortal(
        show
            ? (
                <>
                    <ModalBackdrop
                        className={`modal-backdrop fade show`}
                        onClick={onDismiss}
                    ></ModalBackdrop>
                    <ModalWrapper
                        className={`modal fade show ${className}`}
                        role="dialog"
                        aria-modal="true"
                        onClick={onDismiss}
                    >
                        <ModalDialog
                            className="modal-dialog"
                            onClick={(e) => e.stopPropagation()}
                            size={size}
                        >
                            <div className="modal-content">{children}</div>
                        </ModalDialog>
                    </ModalWrapper>
                </>
            ) 
            : null, 
            document.body
    );
};

export default Modal;